var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { "text-xs-center": "", "pa-2": "" } },
    [
      _c(
        "v-btn",
        {
          staticClass: "paginator__btn first",
          attrs: { id: "btn-first" },
          on: { click: _vm.handleFirst }
        },
        [_vm._v(" << ")]
      ),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          staticClass: "paginator__btn previous",
          on: { click: _vm.handlePrevious }
        },
        [_vm._v(" < ")]
      ),
      _vm._v(" "),
      _vm.total < 15
        ? _vm._l(_vm.total, function(n) {
            return _c(
              "v-btn",
              {
                key: n,
                staticClass: "paginator__btn page--number white--text",
                attrs: { color: _vm.value === n ? "primary" : "greyDark" },
                on: {
                  click: function($event) {
                    _vm.handleBtnClick(n)
                  }
                }
              },
              [_vm._v("\n            " + _vm._s(n) + "\n        ")]
            )
          })
        : [
            _vm.dtDiff
              ? _c(
                  "v-btn",
                  {
                    key: 1,
                    staticClass: "paginator__btn page--number white--text",
                    attrs: { color: _vm.value === 1 ? "primary" : "greyDark" },
                    on: {
                      click: function($event) {
                        _vm.handleBtnClick(1)
                      }
                    }
                  },
                  [_vm._v("\n                1\n            ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.dtDiff
              ? _c("span", { staticClass: "paginator--dots" }, [_vm._v("...")])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.dtTotalExceedLimit, function(n) {
              return [
                n + _vm.dtDiff < _vm.total
                  ? _c(
                      "v-btn",
                      {
                        key: n + _vm.dtDiff,
                        staticClass: "paginator__btn page--number white--text",
                        attrs: {
                          color:
                            _vm.value === n + _vm.dtDiff
                              ? "primary"
                              : "greyDark"
                        },
                        on: {
                          click: function($event) {
                            _vm.handleBtnClick(n + _vm.dtDiff)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(n + _vm.dtDiff) +
                            "\n                "
                        )
                      ]
                    )
                  : _vm._e()
              ]
            }),
            _vm._v(" "),
            _vm.total > _vm.dtDiff + _vm.dtTotalExceedLimit
              ? _c("span", { staticClass: "paginator--dots" }, [_vm._v("...")])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "v-btn",
              {
                key: _vm.total,
                staticClass: "paginator__btn page--number white--text",
                attrs: {
                  color: _vm.value === _vm.total ? "primary" : "greyDark"
                },
                on: {
                  click: function($event) {
                    _vm.handleBtnClick(_vm.total)
                  }
                }
              },
              [
                _vm._v(
                  "\n               " + _vm._s(_vm.total) + "\n            "
                )
              ]
            )
          ],
      _vm._v(" "),
      _c(
        "v-btn",
        { staticClass: "paginator__btn next", on: { click: _vm.handeNext } },
        [_vm._v("\n       >\n    ")]
      ),
      _vm._v(" "),
      _c(
        "v-btn",
        { staticClass: "paginator__btn last", on: { click: _vm.handleLast } },
        [_vm._v(" >> ")]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10499857", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10499857","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/paginator/template.html
// module id = null
// module chunks = 